import { _DEBUG } from './constants';
import { getCookie, setCookie } from './cookies';
import { removeLoadingScreen, showLoadingScreen } from './loadingScreen';
import { getShopCode } from './utils';

// TODO Use arrow functions in this file

/**
 * collection of globally useful utilities
 * @namespace aponeo
 */
const aponeo = {};
(function ($, win) {
  // closure to cache some jQuery calls
  let header = $('.header');
  /**
   * get current height of the header bar
   *
   * @return {int}
   */
  aponeo.headerHeight = function () {
    return header.height();
  };

  let _htmlBody = $('html, body');

  aponeo.log = function (message) {
    if (_DEBUG) {
      console.log(message);
    }
  };

  /**
   * like $('html,body').scrollTop but accounts for the fixed header
   *
   * @param {int|jQuery} top, pixel offset from the top of the document or an element to scroll to
   * @param {int} [duration] of the animation (default 300ms)
   * @function aponeo.scrollTop
   */
  aponeo.scrollTop = function (top, duration) {
    if (typeof top == 'object') {
      top = top.offset().top;
    }
    let target = top - aponeo.headerHeight();
    if (typeof duration == 'undefined') {
      duration = 450;
    }
    if (duration === 0) {
      _htmlBody.scrollTop(target);
    } else {
      _htmlBody.animate({ scrollTop: target }, duration);
    }
  };

  /**
   * Show loading screen
   */
  aponeo.showLoadingScreen = function () {
    $('body').addClass('loading');
    window.setTimeout(aponeo.hideLoadingScreen, 5000);
  };

  /**
   * hide loading screen
   * Todo there is also removeLoadingScreen
   */
  aponeo.hideLoadingScreen = function () {
    $('body').removeClass('loading');
  };

  aponeo.addNotificationList = function (messages) {
    for (let i = 0, length = messages.length; i < length; i++) {
      let msgData = messages[i];
      aponeo.addNotification(msgData[0], msgData[1]);
    }
  };

  aponeo.clearInput = function () {
    $('.apn-clear-input').each((i, elem) => {
      const hasInputClass = 'has-input';
      const toggleClearInputButton = function () {
        const $input = $('input', elem).first();
        $input.toggleClass(hasInputClass, $input.val().length > 0);
      };
      $(elem)
        .off('input.clearInput')
        .on('input.clearInput', () => {
          toggleClearInputButton();
        });
      $('button', elem)
        .off('click.clearInput')
        .on('click.clearInput', () => {
          $('input', elem).first().val('').removeClass(hasInputClass).focus();
        });
      toggleClearInputButton();
    });
  };
  aponeo.clearInput();

  /**
   * Build the symbol.svg URL for the current shop.
   *
   * @param {string} name Symbol name
   * @return {string}
   */
  function buildSymbolUrl(name) {
    const shopCode = getShopCode();
    const basePath = '/images/' + shopCode + '/resplayout/symbol.svg';

    // TODO: Evaluate if for aponeo_de, this should fall through:
    // '/images/resplayout/symbol.svg'

    return basePath + '#' + name;
  }

  /**
   * Build notification HTML matching the partial_notification.tpl markup.
   *
   * @param {string} message Message HTML
   * @param {int}    type     0=success, 1=error, 2=warning, default=info
   * @return {string}
   */
  aponeo.buildNotificationHtml = function (message, type) {
    let alertClass = 'alert-info';
    let alertRole = 'status';
    let iconName = 'info_circle';
    let iconLabel = 'Information:';

    if (type == 0) {
      alertClass = 'alert-success';
      alertRole = 'status';
      iconName = 'check_circle';
      iconLabel = 'Erfolg:';
    } else if (type == 1) {
      alertClass = 'alert-danger';
      alertRole = 'alert';
      iconName = 'x_circle';
      iconLabel = 'Fehler:';
    } else if (type == 2) {
      alertClass = 'alert-warning';
      alertRole = 'alert';
      iconName = 'exclamation_circle';
      iconLabel = 'Warnung:';
    }

    return (
      '<div class="alert ' +
      alertClass +
      ' message message-ajax d-flex align-items-center" role="' +
      alertRole +
      '">' +
      '<svg class="message-icon flex-shrink-0 mr-2" width="24" height="24" viewBox="0 0 100 100" focusable="false" role="img" aria-label="' +
      iconLabel +
      '">' +
      '<use xlink:href="' +
      buildSymbolUrl(iconName) +
      '"></use>' +
      '</svg>' +
      '<div class="message-text flex-grow-1">' +
      '<span class="sr-only">' +
      iconLabel +
      '</span>' +
      '<div>' +
      message +
      '</div>' +
      '</div>' +
      '</div>'
    );
  };

  aponeo.addNotification = function (message, type) {
    // add messages container if none exists
    if (!$('#notification-lines').length) {
      $('main > .breadcrumbs').after($('<div id="notification-lines" aria-live="polite" aria-atomic="false"></div>'));
    }

    $('#notification-lines').append($(aponeo.buildNotificationHtml(message, type)));
  };

  aponeo.refreshCaptcha = function () {
    // force browser to reload the image
    let newSrc = '/sec-img.php?v=' + new Date().getTime();
    $('img[src="/sec-img.php"]').each(function () {
      this.src = newSrc;
    });
  };

  aponeo.showAppInstallBanner = function ($this) {
    $this.removeClass('d-none');
    let $closeButton = $this.find('.apn-app-install-close');
    $closeButton.click(function (e) {
      e.preventDefault();
      $this.addClass('js-dismissed');
      setCookie('appInstallBannerDismissed', '1', 1);
    });
  };
  aponeo.isAndroid = function () {
    return navigator.userAgent.toLowerCase().indexOf('android') > -1;
  };
  aponeo.isMobile = function () {
    // @see http://detectmobilebrowsers.com/
    let isMobile = false;
    (function (uaString) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          uaString,
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          uaString.substr(0, 4),
        )
      )
        isMobile = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return isMobile;
  };
  aponeo.isTablet = function () {
    let isTablet = false;
    (function (uaString) {
      if (
        /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(
          uaString,
        )
      )
        isTablet = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return isTablet;
  };
  if (aponeo.isAndroid() && aponeo.isMobile() && getCookie('appInstallBannerDismissed') !== '1') {
    let $appInstallBanner = $('#apn-app-install');
    if ($appInstallBanner.length > 0) {
      aponeo.showAppInstallBanner($appInstallBanner);
    }
  }

  /**
   * Quick jQuery plugin to check if an element is in the current view
   */
  let $w = $(win);
  /** @returns {boolean} */
  $.fn.isInViewport = function () {
    let elementTop = $(this).offset().top;
    let elementBottom = elementTop + $(this).outerHeight();
    let viewportTop = $w.scrollTop();
    let viewportBottom = viewportTop + $w.height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  // AJAX cart:
  let cartTemplate =
    '<div class="popover cart-popover d-none d-lg-block" role="tooltip"><div class="arrow"></div><h3 class="popover-header text-center apn-text-16 font-secondary font-weight-bold py-2"></h3><div class="popover-body"></div></div>';

  /**
   * AJAX cart object
   * @usage cart is available in a global variable apnCart
   * apnCart.add(productId, qty)
   * apnCart.remove(basketItemId)
   * update happens automatically
   * @param elem
   * @constructor
   */
  function Cart(elem) {
    this.popoverElem = elem;
    this.popoverCallback = this.setupPopover;
    this.update();
  }

  Cart.prototype = {
    cartTemplate: cartTemplate,
    add: function (id, qty, code) {
      let self = this;
      showLoadingScreen();

      let currunturl = window.location.pathname;

      if (currunturl.indexOf('warenkorb') !== -1) {
        // On basket page we need a full refresh page and also a success message
        // So lets use the oldschool post submit functions
        let form = $(
          '<form id="recohelperform_' +
            id +
            '" action="" method="post"><input type="hidden" name="abskt" value="' +
            id +
            '" /><input type="hidden" name="amnt" value="' +
            qty +
            '" /></form>',
        );
        $('body').append(form);
        $('#recohelperform_' + id).submit();
      } else {
        let data = {
          abskt: id,
          amnt: qty,
        };
        if (code) {
          // Seems to be an erx scan
          $('.apn-add2cart-reco').remove(); // Remove add2Cart-Reco recipe
          data.code = btoa(JSON.stringify(code));
        }

        $.ajax({
          url: '/rpc.php?action=addtobasket',
          data: data,
          method: 'GET',
        }).done((response) => {
          removeLoadingScreen();
          self.update();

          //console.log('addtoBasket finished!!!');
          //console.log(response);

          // For adding more than one product optimize the success overlay:
          if (response.headline_succ.length > 5) {
            $('#modal-productAdded #modal-title').html(response.headline_succ);
            $('#modal-productAdded #modal-body').html(response.html_succ);
            if (response.headline_failed.length > 5) {
              $('#modal-productAdded #modal-title2').html(response.headline_failed);
              $('#modal-productAdded #modal-body2').html(response.html_failed);
            } else {
              $('#modal-productAdded #modal-header2').remove();
              $('#modal-productAdded #modal-body2').remove();
            }
          } else {
            $('#modal-productAdded #modal-title').html(response.headline_failed);
            $('#modal-productAdded #modal-body').html(response.html_failed);
            $('#modal-productAdded #modal-header2').remove();
            $('#modal-productAdded #modal-body2').remove();
          }
          // these 2 cases are for an erx article only #Sonderlocke
          if (response._apn_addtobasket_overlay_title_cart.length > 0) {
            $('#_apn_addtobasket_overlay_title_cart').text(response._apn_addtobasket_overlay_title_cart);
          }
          if (response._apn_addtobasket_overlay_title_dismiss.length > 0) {
            $('#_add2cart_button_1').removeClass('btn-inverse');
            $('#_add2cart_button_2').addClass('btn-inverse');
            $('#_apn_addtobasket_overlay_title_dismiss').text(response._apn_addtobasket_overlay_title_dismiss);
          }

          $('#modal-productAdded').modal();
        });
      }
    },
    remove: function (id) {
      let self = this;
      $.ajax({
        url: '/rpc.php?action=removefrombasket',
        data: { abskt: id },
        method: 'POST',
      }).done(function (response) {
        self.update();
        self.showMessages(response.messages);
      });
    },
    update: function () {
      if (!this.getPopoverElem() || !this.getPopoverElem().length) {
        return; // avoid AJAX call if the target is not set
      }
      let self = this;
      $.ajax({
        url: '/rpc.php',
        data: { action: 'ajaxbasket' },
      }).done(function (response) {
        if (_DEBUG) console.log('++++++LiveBasketLoaded-->:');
        if (_DEBUG) console.log(response);

        live_basket = response.items;

        /* Remove every possibly add2Cart Reco of an product that is in the basket */
        for (let cartitem of response.items) {
          // You can use `let` instead of `const` if you like
          $('._add2cart-reco_pzn_' + cartitem.pro_pzn).remove();
        }
        $('.apn-add2cart-reco').show(); // If we are shure there is no, we can try to show the add2cart reco

        let count = response.count || 0;
        self.setCount(count);
        self.popoverCallback(response);
      });
    },
    setupPopover: function (response) {
      if (response.count == 0) {
        return; // nothing to do
      }
      setupCartPopover(this.getPopoverElem(), response.popover, this.cartTemplate);
      this.popoverCallback = this.updatePopover;
    },
    updatePopover: function (response) {
      this.getPopoverElem().popover('dispose');
      if (response.count == 0) {
        // no popover for empty carts
        return;
      }
      // workaround: there is no obvious way to change the html content of a popover
      setupCartPopover(this.getPopoverElem(), response.popover, this.cartTemplate);
    },
    getPopoverElem: function () {
      return this.popoverElem;
    },
    setCount: function (count) {
      $('#header-basket-item-count').html(count).removeClass('apn-hidden');
    },
    showMessages: function (messages) {
      if (!messages) {
        return;
      }
      for (let i = 0, length = messages.length; i < length; i++) {
        let msgData = messages[i];
        aponeo.addNotification(msgData[0], msgData[1]);
      }
    },
  };

  $(document).ready(function () {
    //-----------------------------------
    // ### Aponeo AddressSuggest ###
    //------------------------------------
    // safe to use the function, not on every page loeaded
    if (typeof useAddressSuggestDefault !== 'undefined' && useAddressSuggestDefault) {
      $('input#cus_city').jsonSuggest({
        url: '/rpc.php?action=plzort',
        maxResults: 12,
        minCharacters: 0,
        depend_formvalue: 'cus_zip',
        depend_formvalue2: 'cus_country',
      });
      $('input#cus_street').jsonSuggest({
        url: '/rpc.php?action=plzstr',
        maxResults: 12,
        minCharacters: 1,
        depend_formvalue: 'cus_zip',
        depend_formvalue2: 'cus_country',
      });
    }
  });

  //-----------------------------------
  // ### Aponeo Show/Hide Tables ###
  // TODO: Figure out if this can be removed
  //------------------------------------
  $(document).ready(function () {
    $('.js-open-table').on('click touch', function () {
      let target = $(this).data('table');
      if ($(target).hasClass('closed')) {
        $(this).removeClass('closed');
        $(target).removeClass('closed');
      } else {
        $(this).addClass('closed');
        $(target).addClass('closed');
        $('html, body').animate(
          {
            scrollTop: $(target).offset().top - 100,
          },
          300,
        );
      }
    });
  });

  //-----------------------------------
  // ### customized used in basket for recipe only
  //------------------------------------
  $(document).ready(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });

  let popOverHystereseDelay = 100;
  //-----------------------------------
  // ### Aponeo Account Popover ###
  //------------------------------------
  function setupAccountPopover(elem, content) {
    let accountTemplate =
      '<div class="popover account-popover d-none d-lg-block" role="tooltip"><div class="arrow"></div><h3 class="popover-header text-center apn-text-16 font-secondary font-weight-bold py-2"></h3><div class="popover-body"></div></div>';

    function hideAccountPopover() {
      // there is a small gap between elem and popover, that's why there is a small timeout before popover hide
      setTimeout(function () {
        let elemIsHovered = $(elem).is(':hover'),
          popOverIsHovered = $('.popover.account-popover:hover').length > 0;

        // only hide content when both are not hovered
        if (!elemIsHovered && !popOverIsHovered) {
          elem.popover('hide');
        }
      }, popOverHystereseDelay);
    }

    elem
      .popover({
        container: 'body',
        html: true,
        content: content,
        template: accountTemplate,
        placement: 'bottom',
        trigger: 'manual',
        delay: {
          show: 0,
          hide: 0,
        },
      })
      .on('show.bs.popover', function () {
        $(content).removeClass('d-none');
      })
      .on('mouseenter', function () {
        elem.popover('show');
      })
      .on('mouseleave', function () {
        hideAccountPopover();
      });

    $('body').on('mouseleave', '.popover.account-popover', function (e) {
      if (!$(e.target).is('.form-control')) {
        hideAccountPopover();
      }
    });

    // clicks in the popover stay in the popover
    $('body').on('click', '.popover.account-popover', function (e) {
      e.stopPropagation();
    });
  }

  if (header.find('.account-popover-content').length) {
    setupAccountPopover(header.find('.header-account'), $('.account-popover-content'));
  }

  //-----------------------------------
  // ### Aponeo Cart Popover ###
  //------------------------------------

  // function is shared between the prototype and production site
  function setupCartPopover(elem, content, template) {
    function hideCartPopover() {
      // there is a small gap between elem and popover, that's why there is a small timeout before popover hide
      setTimeout(function () {
        let elemIsHovered = $(elem).is(':hover'),
          popOverIsHovered = $('.popover.cart-popover:hover').length > 0;

        // only hide content when both are not hovered
        if (!elemIsHovered && !popOverIsHovered) {
          elem.popover('hide');
        }
      }, popOverHystereseDelay);
    }

    elem
      .popover({
        container: 'body',
        html: true,
        template: template,
        content: content,
        placement: 'bottom',
        title: 'Ihr Warenkorb',
        trigger: 'focus',
        delay: {
          show: 0,
          hide: 0,
        },
      })
      .on('mouseenter', function () {
        $(this).trigger('focus');
      })
      .on('mouseleave', function () {
        hideCartPopover();
      });

    $('body').on('mouseleave', '.popover.cart-popover', function (e) {
      hideCartPopover();
    });
  }

  if (header.find('.cart-popover-content').length) {
    // prototype functionality:
    setupCartPopover(header.find('.header-cart'), $('.cart-popover-content'), cartTemplate);
    $('#header-basket-item-count').html(2).removeClass('apn-hidden');
  } else {
    win.apnCart = new Cart(header.find('.header-cart'));
  }

  //-----------------------------------
  // ### Aponeo Service Popover ###
  //------------------------------------
  function setupServicePopover(elem, content) {
    let serviceTemplate =
      '<div class="popover apn-service-popover d-none d-lg-block" role="tooltip"><div class="arrow"></div><h3 class="popover-header text-center apn-text-16 font-secondary font-weight-bold py-2"></h3><div class="popover-body"></div></div>';

    function hideServicePopover() {
      // there is a small gap between elem and popover, that's why there is a small timeout before popover hide
      setTimeout(function () {
        let elemIsHovered = $(elem).is(':hover'),
          popOverIsHovered = $('.popover.apn-service-popover:hover').length > 0;

        // only hide content when both are not hovered
        if (!elemIsHovered && !popOverIsHovered) {
          elem.popover('hide');
        }
      }, popOverHystereseDelay);
    }

    elem
      .popover({
        container: 'body',
        html: true,
        content: content,
        template: serviceTemplate,
        placement: 'bottom',
        trigger: 'manual',
        delay: {
          show: 0,
          hide: 0,
        },
      })
      .on('show.bs.popover', function () {
        $(content).removeClass('d-none');
      })
      .on('mouseenter', function () {
        elem.popover('show');
      })
      .on('mouseleave', function () {
        hideServicePopover();
      });

    $('body').on('mouseleave', '.popover.apn-service-popover', function (e) {
      hideServicePopover();
    });
  }

  if (header.find('.apn-service-popover-content').length) {
    setupServicePopover(header.find('.apn-header-service'), $('.apn-service-popover-content'));
  }

  //--- Interktionscheck

  if (aponeo.isMobile()) {
    $('.apn-is-mobile').css('display', 'block');
    $('.apn-is-not-mobile').css('display', 'none');
  } else {
    $('.apn-is-mobile').css('display', 'none');
    $('.apn-is-not-mobile').css('display', 'block');
  }
})(jQuery, window);

export default aponeo;
